import { useLocalStorage } from 'usehooks-ts';
import type { Version } from '@bentley/pw-config';
import { isVersionGreaterThan, parseVersion } from '@bentley/pw-config';
import packageInfo from '../../../package.json';

type AppVersionManager = {
  appVersion: Version;
  newFeaturesAvailable: () => boolean;
  updateAppVersion: () => void;
};

export function useAppVersion(): AppVersionManager {
  const [appVersion, setAppVersion] = useLocalStorage<Version>(
    'welcomeModalLastViewed',
    { major: 0, minor: 0, patch: 0 }
  );

  const currentAppVersion = parseVersion(packageInfo.version);

  function newFeaturesAvailable() {
    return isVersionGreaterThan(currentAppVersion, appVersion, 'minor');
  }

  function updateAppVersion(): void {
    setAppVersion(currentAppVersion);
  }

  return {
    appVersion,
    newFeaturesAvailable,
    updateAppVersion
  };
}
